/**
 * 状态分步统计
 */
import { STATUSDISTRIBUTESTATISTICS } from '../types';

export default {
    name: `${STATUSDISTRIBUTESTATISTICS}`,
    path: '/statusDistributeStatistics',
    component: () => import(/* webpackChunkName: 'statusDistributeStatistics' */ '@/views/statusDistributeStatistics/'),
    redirect: { name: `${STATUSDISTRIBUTESTATISTICS}Index` },
    meta: {
        title: '状态分布统计',
        savedPosition: { x: 0, y: 0 },
        noCache: true,
    },
    children: [
        {
            name: `${STATUSDISTRIBUTESTATISTICS}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'statusDistributeStatistics' */ '@/views/statusDistributeStatistics/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${STATUSDISTRIBUTESTATISTICS}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'statusDistributeStatistics' */ '@/views/statusDistributeStatistics/detail/Detail.vue'),
        // },
    ],
};
